export default "__VITE_ASSET__854d188d__"